import { MapProps } from "react-map-gl/maplibre";
import { useDispatch, useSelector } from "react-redux";

import { AppDispatch } from "../../../App";
import { getMap, setMap, setMouseLocation, updateBoundsAndZoom } from "../../../state/map";
let dontCall = 0;

// We move the tooltip from the deckgl container to the maplibre container.
// This allows the tooltip to be on top of the street labels
const moveToolTipElement = () => {
  const canvasContainer = document.querySelector(".maplibregl-canvas-container");
  if (!canvasContainer) return;
  const canvasContainerHasTooltip = !!canvasContainer.querySelector(".deck-tooltip");
  if (canvasContainerHasTooltip) return;
  const toolTipElement = document.querySelector(".deck-tooltip");
  if (!toolTipElement) return;
  canvasContainer.appendChild(toolTipElement);
};

const MapLibreEventsHandler = (): MapProps => {
  const dispatch = useDispatch() as AppDispatch;
  const map = useSelector(getMap);
  return {
    onLoad: ({ target }) => {
      moveToolTipElement();
      dispatch(setMap(target));
    },
    onMouseMove: (e) => {
      if (!map) return;
      // Handle mouse move gets called way too often so this slows it down a bit
      if (dontCall) return dontCall--;
      dontCall += 2;
      dispatch(setMouseLocation([e.lngLat.lng, e.lngLat.lat]));
    },
    onMoveEnd: () => {
      dispatch(updateBoundsAndZoom());
    },
  };
};

export default MapLibreEventsHandler;
